// ============================================================================
// Core Types
// ============================================================================

export const DAYS_OF_WEEK = [
  { value: 'monday', label: 'Monday' },
  { value: 'tuesday', label: 'Tuesday' },
  { value: 'wednesday', label: 'Wednesday' },
  { value: 'thursday', label: 'Thursday' },
  { value: 'friday', label: 'Friday' },
  { value: 'saturday', label: 'Saturday' },
  { value: 'sunday', label: 'Sunday' },
] as const;

export type DayOfWeek = typeof DAYS_OF_WEEK[number]['value'];

/**
 * Time string in HH:mm format (24-hour time)
 * Format is enforced by HTML time input elements
 * @example "09:00", "17:30", "23:59"
 */
export type TimeString = string;

// Type for backend duty response
export type Duty = {
  id: string;
  key: string;
  name: string;
  description: string;
};

// Type for backend SiteDuty requirement response
export type SiteDutyConfig = {
  id: string;
  siteId: string;
  duty: Duty;
  day: DayOfWeek;
  requirements: DutyRequirement[] | null;
};

export type DutyRequirement = {
  startTime: TimeString;
  endTime: TimeString;
  minPersonnel: number;
};

export type DutyConfiguration = {
  duty: Duty;
  requirements: DutyRequirement[] | null;
};
